module.exports = __webpack_public_path__ + "img/block.a3043f6d.jpg";